/* Optional, explicitly confirmed back-side engraving. Native nested Shopify lines. */
(function(root){
  'use strict';
  var FEE=51761795170550, PAIR_FEE=51807242911990, HANDLE='charm-back-side-engraving-3';
  var TEXT='Charm Back-side Engraving', PRODUCT='_ss_back_engraving_product', GROUP='_ss_back_engraving_group';
  var CONSENT='Back-side engraving fee', CONFIRMED='$5.00 USD per charm (confirmed)';
  function text(v){return v==null?'':String(v).trim();}
  var CONFIRMED_PAIR='$5.00 USD per pair (confirmed)';
  function confirmedFor(unit){return unit==='pair'?CONFIRMED_PAIR:CONFIRMED;}
  function isConfirmed(value){return value===CONFIRMED||value===CONFIRMED_PAIR;}
  function feeFor(unit){return unit==='pair'?PAIR_FEE:FEE;}
  function fee(i){var id=Number(i.variant_id||i.id);return id===FEE||id===PAIR_FEE;}
  function parent(child,items){
    var key=child.parent_relationship&&child.parent_relationship.parent_key;
    return items.find(function(i){return !fee(i)&&(key?i.key===key:text((i.properties||{})[GROUP])&&text((i.properties||{})[GROUP])===text((child.properties||{})[GROUP]));});
  }
  function decode(body){
    if(body&&typeof body==='object'&&!(body instanceof URLSearchParams)&&!(typeof FormData!=='undefined'&&body instanceof FormData))return body;
    if(typeof body==='string'&&body.trim().charAt(0)==='{')return JSON.parse(body);
    var result={},items=[],entries=typeof body==='string'?new URLSearchParams(body):body;
    if(!entries||!entries.forEach)return null;
    entries.forEach(function(value,key){
      var m=key.match(/^items\[(\d+)\]\[properties\]\[(.*)\]$/);
      if(m){var item=items[+m[1]]||(items[+m[1]]={});(item.properties||(item.properties={}))[m[2]]=value;return;}
      m=key.match(/^items\[(\d+)\]\[([^\]]+)\]$/);
      if(m){(items[+m[1]]||(items[+m[1]]={}))[m[2]]=value;return;}
      m=key.match(/^properties\[(.*)\]$/);
      if(m){(result.properties||(result.properties={}))[m[1]]=value;return;}
      result[key]=value;
    });
    if(items.length)result.items=items.filter(Boolean);
    return result;
  }
  function encode(data,original){
    var multipart=typeof FormData!=='undefined'&&original instanceof FormData;
    if(!multipart&&!(original instanceof URLSearchParams)&&typeof original!=='string')return data;
    if(typeof original==='string'&&original.trim().charAt(0)==='{')return JSON.stringify(data);
    var body=multipart?new FormData():new URLSearchParams();
    function put(key,value){if(value!==undefined&&value!==null)body.append(key,value);}
    Object.keys(data).forEach(function(key){
      if(key==='items')data.items.forEach(function(item,n){Object.keys(item).forEach(function(k){if(k==='properties')Object.keys(item[k]).forEach(function(p){put('items['+n+'][properties]['+p+']',item[k][p]);});else put('items['+n+']['+k+']',item[k]);});});
      else if(key==='properties')Object.keys(data[key]).forEach(function(p){put('properties['+p+']',data[key][p]);});
      else put(key,data[key]);
    });
    return typeof original==='string'?body.toString():body;
  }
  function prepare(data,eligible,makeGroup){
    if(!data)return null;
    var single={id:data.id,quantity:data.quantity,properties:data.properties};
    if(data.selling_plan)single.selling_plan=data.selling_plan;
    var items=(data.items||[single]).map(function(i){return Object.assign({},i,{properties:Object.assign({},i.properties||{})});});
    var changed=false,children=[];
    items.forEach(function(item){
      if(fee(item))return;
      var p=item.properties,config=eligible[text(p[PRODUCT])];
      if(!config)return; // Eligibility is supplied only by a server-rendered tagged block.
      if(!text(p[TEXT])){
        [TEXT,PRODUCT,GROUP,CONSENT].forEach(function(k){delete p[k];});changed=true;return;
      }
      if(p[CONSENT]!==confirmedFor(config.unit))throw new Error('Please confirm the additional $5.00 USD per '+(config.unit==='pair'?'pair':'charm')+' for back-side engraving.');
      if(config.max>0&&String(p[TEXT]).length>config.max)throw new Error('Please shorten your back-side engraving to '+config.max+' characters.');
      var quantity=Number(item.quantity||1);
      if(!Number.isSafeInteger(quantity)||quantity<1)throw new Error('Please choose a valid charm quantity.');
      if(items.filter(function(i){return String(i.id)===String(item.id);}).length!==1)throw new Error('Please add each engraved charm separately.');
      p[GROUP]=text(p[GROUP])||makeGroup();
      var existing=items.filter(function(i){return fee(i)&&text((i.properties||{})[GROUP])===p[GROUP];});
      if(existing.length>1)throw new Error('Please refresh the page before adding your engraving.');
      if(existing.length){existing[0].id=feeFor(config.unit);existing[0].quantity=quantity;existing[0].parent_id=item.id;}
      else children.push({id:feeFor(config.unit),quantity:quantity,parent_id:item.id,properties:{'_ss_back_engraving_group':p[GROUP],'_ss_back_engraving_service':'5.00 USD','Engraving for':String(p[TEXT])}});
      changed=true;
    });
    if(!changed)return null;
    var result=Object.assign({},data,{items:items.concat(children)});
    ['id','quantity','properties','selling_plan'].forEach(function(k){delete result[k];});
    return result;
  }
  var api={feeVariant:FEE,pairFeeVariant:PAIR_FEE,confirmedFor:confirmedFor,isConfirmed:isConfirmed,fee:fee,parent:parent,decode:decode,encode:encode,prepare:prepare,keys:{text:TEXT,product:PRODUCT,group:GROUP,consent:CONSENT},confirmed:CONFIRMED};
  if(typeof module==='object'&&module.exports)module.exports=api;
  if(!root.document)return;
  if(root.SoulyshineEngraving)return;
  root.SoulyshineEngraving=api;
  var doc=root.document,nativeFetch=root.fetch.bind(root),pending=0,checking=false,allowCheckout=false;
  var route=function(path){return ((root.Shopify&&root.Shopify.routes&&root.Shopify.routes.root)||'/').replace(/\/?$/,'/')+path;};
  function configs(){var map={};doc.querySelectorAll('[data-ss-engraving-product]').forEach(function(el){map[el.dataset.ssEngravingProduct]={max:Number(el.dataset.ssEngravingMax)||0,unit:el.dataset.ssEngravingUnit==='pair'?'pair':'charm'};});return map;}
  function group(){return root.crypto&&root.crypto.randomUUID?root.crypto.randomUUID():'engraving-'+Date.now()+'-'+Math.random().toString(36).slice(2);}
  function transform(body){var data=decode(body),result=prepare(data,configs(),group);return result?encode(result,body):null;}
  api.prepareFormData=function(fd){var result=transform(fd);if(!result)return;Array.from(fd.keys()).forEach(function(k){fd.delete(k);});result.forEach(function(v,k){fd.append(k,v);});};
  function addURL(url){try{var u=new URL(url,root.location.href);return u.origin===root.location.origin&&/\/cart\/add(?:\.js)?$/.test(u.pathname);}catch(_){return false;}}
  // Installed before apps capture fetch. Preserve their request/response contracts.
  root.fetch=async function(input,options){
    var url=input instanceof Request?input.url:String(input);
    if(!addURL(url))return nativeFetch(input,options);
    var opts=Object.assign({},options||{}),body=opts.body;
    try{
      if(input instanceof Request&&body===undefined){var copy=input.clone();var type=copy.headers.get('Content-Type')||'';body=/multipart\/form-data/.test(type)?await copy.formData():await copy.text();}
      if(body!==undefined){var next=transform(body);if(next!==null){opts.body=next;if(input instanceof Request)input=new Request(input,opts);}}
    }catch(e){showError(e.message);return new Response(JSON.stringify({status:422,message:e.message,description:e.message}),{status:422,headers:{'Content-Type':'application/json'}});}
    pending++;
    try{return await nativeFetch(input,opts);}finally{pending--;}
  };
  function showError(message){
    var el=doc.getElementById('ss-engraving-cart-error');
    if(!el){el=doc.createElement('p');el.id='ss-engraving-cart-error';el.setAttribute('role','alert');el.style.cssText='padding:12px;background:#fff1f0;color:#9b1c1c;position:fixed;bottom:20px;left:5%;width:90%;z-index:100000;';doc.body.appendChild(el);}
    el.textContent=message;el.hidden=false;
  }
  async function json(path,body){
    var r=await nativeFetch(route(path),{credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},method:body?'POST':'GET',body:body?JSON.stringify(body):undefined});
    var data=await r.json();if(!r.ok||data.errors)throw new Error(data.description||'Your cart could not be checked. Please try again.');return data;
  }
  function confirmLegacy(items){
    return new Promise(function(resolve){
      var dialog=doc.createElement('dialog');dialog.style.cssText='max-width:440px;width:90%;padding:24px;border:1px solid #ddd;border-radius:12px;z-index:100001';
      var title=doc.createElement('h2');title.textContent='Confirm back-side engraving';title.style.fontSize='20px';dialog.appendChild(title);
      var p=doc.createElement('p');p.textContent='Your cart includes '+items.reduce(function(s,i){return s+i.quantity;},0)+' charm(s) with back-side text. Engraving costs an additional $5.00 USD per charm.';dialog.appendChild(p);
      function button(label,value){var b=doc.createElement('button');b.type='button';b.textContent=label;b.style.cssText='display:block;width:100%;padding:12px;margin-top:10px;cursor:pointer';b.onclick=function(){dialog.close();dialog.remove();resolve(value);};dialog.appendChild(b);}
      button('Confirm engraving fee',true);button('Continue without back-side engraving',false);button('Back to cart',null);
      dialog.addEventListener('cancel',function(e){e.preventDefault();dialog.remove();resolve(null);});doc.body.appendChild(dialog);dialog.showModal();
    });
  }
  async function verifyCart(){
    if(pending)throw new Error('Your product is still being added. Please try checkout in a moment.');
    var cart=await json('cart.js'),products={},units={};
    if(!cart.items.some(function(i){return fee(i)||text((i.properties||{})[TEXT]);}))return true;
    for(var item of cart.items){if(!fee(item)&&text((item.properties||{})[TEXT])){var p=await json('products/'+encodeURIComponent(item.handle)+'.js'),tags=(Array.isArray(p.tags)?p.tags:String(p.tags||'').split(',')).map(text);products[item.product_id]=tags.some(function(tag){return tag===TEXT||tag==='Keychain Back-side Engraving'||tag==='Earrings Back-side Engraving'||tag==='Bracelet Back-side Engraving';});units[item.product_id]=tags.indexOf('Earrings Back-side Engraving')!==-1?'pair':'charm';}}
    var removedEligibility=cart.items.filter(function(i){return !fee(i)&&products[i.product_id]===false&&isConfirmed((i.properties||{})[CONSENT]);});
    for(var stale of removedEligibility){
      var cleaned=Object.assign({},stale.properties);[CONSENT,PRODUCT,GROUP].forEach(function(k){delete cleaned[k];});
      await json('cart/change.js?customily_upsell=1',{id:stale.key,quantity:stale.quantity,properties:cleaned});
    }
    if(removedEligibility.length)cart=await json('cart.js');
    var legacy=cart.items.filter(function(i){return !fee(i)&&products[i.product_id]&&text((i.properties||{})[TEXT])&&(i.properties||{})[CONSENT]!==confirmedFor(units[i.product_id]);});
    if(legacy.length){
      // No checkout popup: the shopper typed the engraving text and saw the +$5 fee line, so confirm it.
      var consent=true;
      for(var old of legacy){
        var props=Object.assign({},old.properties);
        if(consent){props[CONSENT]=confirmedFor(units[old.product_id]);props[PRODUCT]=String(old.product_id);props[GROUP]=group();}
        else [TEXT,CONSENT,PRODUCT,GROUP].forEach(function(k){delete props[k];});
        await json('cart/change.js?customily_upsell=1',{id:old.key,quantity:old.quantity,properties:props});
      }
      cart=await json('cart.js');
    }
    // 22/10: reconcile per engraving GROUP, not per line. Shopify's automatic "Buy 2 Get 1 Free" splits one engraved
    // line of 3 into 2 + 1 (same properties, new keys), so the fee lines must add up to the group's charm count
    // instead of mirroring each line — the per-line check failed on every split cart ("Please review your engraving").
    function plan(c){
      var groups={},order=[],zero={};
      c.items.forEach(function(m){
        var p=m.properties||{};
        if(fee(m)||!products[m.product_id]||!text(p[TEXT])||p[CONSENT]!==confirmedFor(units[m.product_id]))return;
        var g=text(p[GROUP])||m.key;
        if(!groups[g]){groups[g]={mains:[],fees:[],unit:units[m.product_id],text:String(p[TEXT])};order.push(g);}
        groups[g].mains.push(m);
      });
      c.items.filter(fee).forEach(function(ch){
        var g=text((ch.properties||{})[GROUP]);
        if(!g||!groups[g]){var m=parent(ch,c.items);var mp=m&&m.properties||{};g=m&&(text(mp[GROUP])||m.key);}
        if(g&&groups[g]&&Number(ch.variant_id||ch.id)===feeFor(groups[g].unit))groups[g].fees.push(ch);
        else zero[ch.key]=0;
      });
      return {groups:groups,order:order,zero:zero};
    }
    var pl=plan(cart),updates=Object.assign({},pl.zero),missing=[];
    pl.order.forEach(function(g){
      var G=pl.groups[g],want=G.mains.reduce(function(s,m){return s+m.quantity;},0);
      var have=G.fees.reduce(function(s,c){return s+c.quantity;},0);
      if(have===want)return;
      if(!G.fees.length){missing.push({id:feeFor(G.unit),quantity:want,parent_line_key:G.mains[0].key,properties:{'_ss_back_engraving_group':g,'_ss_back_engraving_service':'5.00 USD','Engraving for':G.text}});return;}
      // keep the fee lines as they are and move the difference onto the first one (never below 0)
      var rest=have-G.fees[0].quantity;
      if(want-rest>=0)updates[G.fees[0].key]=want-rest;
      else {updates[G.fees[0].key]=want;G.fees.slice(1).forEach(function(c){updates[c.key]=0;});}
    });
    Object.keys(updates).forEach(function(key){var i=cart.items.find(function(i){return i.key===key;});if(i&&i.quantity===updates[key])delete updates[key];});
    if(Object.keys(updates).length)await json('cart/update.js?customily_upsell=1',{updates:updates});
    if(missing.length)await json('cart/add.js?customily_upsell=1',{items:missing});
    var finalCart=await json('cart.js'),fin=plan(finalCart);
    if(Object.keys(fin.zero).length)throw new Error('Please review your engraving in the cart before checkout.');
    fin.order.forEach(function(g){
      var G=fin.groups[g];
      var want=G.mains.reduce(function(s,m){return s+m.quantity;},0),have=G.fees.reduce(function(s,c){return s+c.quantity;},0);
      if(want!==have)throw new Error('Please review your engraving in the cart before checkout.');
    });
    if(pending)throw new Error('Your cart changed while it was being checked. Please try checkout again.');
    return true;
  }
  api.verifyCart=verifyCart;
  async function checkout(event){
    if(allowCheckout)return;
    var trigger=event.submitter||event.target.closest('button,a,input');
    if(trigger&&trigger.disabled)return;
    var scope=trigger&&trigger.closest('cart-drawer, #main-cart-footer'),tnc=scope&&scope.querySelector('[id^="TNC-Checkbox-"]');
    if(tnc&&tnc.dataset.checked!=='true')return;
    if(trigger&&trigger.form&&!trigger.form.checkValidity()){trigger.form.reportValidity();event.preventDefault();return;}
    if(checking){event.preventDefault();event.stopImmediatePropagation();return;}
    event.preventDefault();event.stopImmediatePropagation();checking=true;
    var button=event.submitter||event.target.closest('button,a,input'),previous=button&&button.disabled;
    if(button&&'disabled' in button)button.disabled=true;
    try{if(await verifyCart()){
      // Resume Shopify's original form so cart notes/attributes are submitted too.
      allowCheckout=true;
      if(button&&'disabled' in button)button.disabled=previous;
      if(button&&button.form)button.form.requestSubmit(button);
      else root.location.assign(button&&button.href||route('checkout'));
      setTimeout(function(){allowCheckout=false;},0);
    }}
    catch(e){showError(e.message);if(root.SoulyshineDrawer)root.SoulyshineDrawer.refresh(false).catch(function(){});}
    finally{checking=false;if(button&&'disabled' in button)button.disabled=previous;}
  }
  doc.addEventListener('click',function(e){var el=e.target.closest&&e.target.closest('[name="checkout"],#CartDrawer-Checkout,a[href]');if(!el)return;var isCheckout=el.name==='checkout'||el.id==='CartDrawer-Checkout';if(el.tagName==='A'){try{var u=new URL(el.href,root.location.href);isCheckout=u.origin===root.location.origin&&/\/checkout\/?$/.test(u.pathname);}catch(_){}}if(isCheckout)checkout(e);},true);
  doc.addEventListener('submit',function(e){if(e.submitter&&e.submitter.name==='checkout')checkout(e);},true);
})(typeof window!=='undefined'?window:globalThis);
